import { useEffect, useRef } from "react";
import { useClearRefinements } from "react-instantsearch";

function FilterClearEffect({ showFilters, onClear }) {
  const { refine } = useClearRefinements();
  const prevRef = useRef(showFilters);

  useEffect(() => {
    if (prevRef.current && !showFilters) {
      refine();
      onClear?.();
    }
    prevRef.current = showFilters;
  }, [showFilters, refine, onClear]);

  return null;
}

export default FilterClearEffect;
